module.exports = __webpack_public_path__ + "img/icon-question-rating-radiobutton.bbd26e5e.svg";